import type { CalendarLayer } from './calendar-sources';

// Home's "Up next" reads the Calendar's shown layers minus the free/busy-only ones. Kept apart with no runtime
// imports so jest runs it without the app's graph. The same rule runs on iOS and Android.

/**
 * The layers whose items can be "up next": the ones shown on the Calendar screen, less any calendar the account
 * sees only as free/busy — someone else's busy blocks are never the owner's next thing, even when that calendar
 * is shown. Pass the result to `itemsOfShownLayers` as its shown set: a free/busy layer is still a known layer, so
 * its items drop, and an item of a layer not listed yet is still kept.
 */
export function upNextLayerIds(layers: Pick<CalendarLayer, 'id' | 'access'>[], shown: Set<string>): Set<string> {
  const freeBusy = new Set(layers.filter((layer) => layer.access === 'free_busy').map((layer) => layer.id));
  return new Set([...shown].filter((id) => !freeBusy.has(id)));
}
